import {
    changeOwnershipStartRequest,
    changeOwnershipCreateRequest,
    changeOwnershipCreateResponse,
    ContinueSignContract,
    ChangeOwnershipStatus,
    CustomerValidation,
    changeOwnershipValidationRequest,
} from '../models/OwnershipChange';
import ApisClient, { ApisClientNoLoader } from '../utils/client/ApisClient';

export const getDocumentValidation = (data: changeOwnershipValidationRequest) => {
    return ApisClient.post<CustomerValidation>('/ownership-change/validation', data);
};

export const getContactMedia = () => {
    return ApisClient.get('/customer/one-time-contact-media');
};

export const getChangeOwnershipStatus = () => {
    return ApisClient.get<ChangeOwnershipStatus>('/ownership-change/status');
};

export const startChangeOwnership = (data: changeOwnershipStartRequest) => {
    return ApisClient.post('/ownership-change/start', data);
};

export const continueChangeOwnership = (data: ContinueSignContract) => {
    return ApisClient.post('/ownership-change/continue', data);
};

export const createCustomer = (data: changeOwnershipCreateRequest) => {
    return ApisClient.post<changeOwnershipCreateResponse>('/ownership-change/create-customer', data);
};

export const getPartialAddressSuggestions = (searchFilter: string) => {
    return ApisClientNoLoader.get('/ubic/search', { params: { searchFilter } });
};

export const getCompleteAddressSuggestions = (searchFilter: string, geographicSiteId: string) => {
    return ApisClientNoLoader.get('/ubic/search/details', { params: { searchFilter, geographicSiteId } });
};

export const getChangeOwnershipStatusNoClient = (signalingId: string) => {
    return ApisClient.get('/ownership-change/status/no-client', { params: { signalingId } });
};

export const cancelChangeOwner = (signalingId: string) => {
    return ApisClient.post('/ownership-change/cancel', { signalingId });
};
